/* eslint-disable */
const _ = require('lodash');

export default {
  async guardRoute(to, from, next) {
    return next();
  },
};
